import React, { useState, useEffect } from 'react';
import { getSalesByTransactionId } from '../service/saleService';
import { getTokenById } from '../service/tokenService';
import { getPaymentByTransactionId } from '../service/paymentService';
import { getNotificationsByTransactionId, sendSms } from '../service/notificationService';
import { toast } from 'react-toastify';
import Moment from 'react-moment';
import { Button } from 'react-bootstrap';
import { MdTextsms, MdPayment, MdNotifications } from 'react-icons/md';
import { FaSms } from 'react-icons/fa';
import { GiMoneyStack } from 'react-icons/gi';
import { GrSecure } from 'react-icons/gr';

export default function SaleHistoryDetails(props) {
   const [sale, setSale] = useState({});
   const [token, setToken] = useState({});
   const [payment, setPayment] = useState({});
   const [notifications, setNotifications] = useState([]);
   const [deliveryStatus, setDeliveryStatus] = useState('');
   const transactionId = props.match.params.transactionId;

   const fetchSales = () => {
      getSalesByTransactionId(transactionId).then((result) => {
         const foundSale = result.data.data;
         setSale(foundSale);
         if (foundSale.tokenId && foundSale.tokenId !== -1) {
            fetchToken(foundSale.tokenId);
         }
         fetchPayments(transactionId);
         fetchNotifications(transactionId);
      });
   };

   const fetchToken = (tokenId) => {
      getTokenById(tokenId)
         .then((result) => {
            const foundToken = result.data.data;
            if (foundToken) setToken(foundToken);
         })
         .catch((error) => {
            toast.error('Error | Could not fetch token ', { autoClose: 1500 });
         });
   };

   const fetchPayments = (transactionId) => {
      getPaymentByTransactionId(transactionId)
         .then((result) => {
            const foundPayment = result.data.data;
            if (foundPayment) setPayment(foundPayment);
         })
         .catch((error) => {
            toast.error('Error | Could not fetch payment ', { autoClose: 1500 });
         });
   };

   const fetchNotifications = (transactionId) => {
      getNotificationsByTransactionId(transactionId)
         .then((result) => {
            const foundNotification = result.data.data;
            if (foundNotification) setNotifications(foundNotification);
         })
         .catch((error) => {
            toast.error('Error | Could not fetch payment ', { autoClose: 1500 });
         });
   };

   const resendSms = (evt) => {
      evt.preventDefault();
      if (notifications.length > 0) {
         const { transactionId, recipient, sender, notificationText } = notifications[0];
         let smsTosend = {
            transactionId,
            recipient,
            sender,
            notificationText,
         };
         sendSms(smsTosend)
            .then((result) => {
               const response = result.data.data;
               console.dir(result.data);
               fetchNotifications(transactionId);
               if (response === '0: Accepted for delivery') {
                  setDeliveryStatus('Sms notification sent successfully');
                  toast.info('Sms notification has been sent', { autoClose: 2000 });
               } else {
                  toast.error('Sms notification not sent', { autoClose: 2000 });
                  setDeliveryStatus(response);
               }
            })
            .catch((error) => {
               if (error.message.includes('Network Error')) {
                  setDeliveryStatus('Network error');
                  toast('Network error - make sure API is running', {
                     autoClose: true,
                  });
               } else {
                  const { status } = error.response;
                  setDeliveryStatus('Failed to send notification');
                  if (status === 404) {
                     toast('Resource Not found !!!', { autoClose: true });
                  }
                  if (status === 500) {
                     toast('Server error - check the terminal for more info', {
                        autoClose: true,
                     });
                  }
               }
            });
      }
   };

   useEffect(fetchSales, []);

   return (
      <div className='row'>
         <div className='col-md-8 offset-md-2'>
            <div className='card card-custom mb-2'>
               <div className='card-body'>
                  <h6 className='card-title text-muted'>
                     Sale Details <GiMoneyStack />
                  </h6>
                  <hr />
                  <div className='card-text d-flex flex-row justify-content-between'>
                     <span className='font-weight-bold'>Transaction #: {sale.transactionId}</span>
                     <span className='font-italic font-weight-light text-muted'>{sale.saleDateTime}</span>
                  </div>
                  <div className='card-text d-flex flex-row justify-content-between'>
                     <span className='font-weight-bold'>Meter: {sale.meterNumber}</span>
                     <span className='font-italic font-weight-light text-muted'>{Object.keys(sale).length > 0 ? sale.customerId.customerNames : 'No status'}</span>
                  </div>
                  <div className='card-text d-flex flex-column justify-content-between'>
                     <div>
                        <span className='font-weight-normal'>Phone Number:</span>
                        <span className='font-italic'>{sale.buyerIdentifier}</span>
                     </div>
                     <div className='card-text d-flex flex-row justify-content-between'>
                        <span className='text-muted font-weight-normal'>Vendor Account:{Object.keys(sale).length > 0 ? sale.vendorAccountId.vendorAccountName : 'No status'}</span>
                        <span className='font-italic font-weight-bold text-info'>{Object.keys(sale).length > 0 ? sale.statusId.saleStatusName : 'No status'}</span>
                     </div>
                  </div>
               </div>
            </div>
            {Object.keys(token).length !== 0 ? (
               <div className='card card-custom-bg card-custom mb-2'>
                  <div className='card-body'>
                     <h6 className='card-title text-muted'>
                        Token Summary <GrSecure />
                     </h6>
                     <hr />
                     <div className='card-text d-flex flex-row justify-content-between'>
                        <span className='font-weight-bold'>Receipt Number: {token.receiptNumber}</span>
                        <span className='font-italic font-weight-light text-muted'>
                           <Moment parse='YYYY-MM-DD HH:mm:ss' format='DD/MM/YYYY HH:mm:ss'>
                              {token.tokenDateTime}
                           </Moment>
                        </span>
                     </div>
                     <div className='card-text d-flex flex-column justify-content-between'>
                        <div>
                           <span className='font-weight-normal'>Purchased Amount : {token.tokenAmount} FRW</span>
                        </div>
                        <div>
                           <span className='font-weight-normal'>Unit : {token.units} Kwh</span>
                        </div>
                        <div>
                           <span className='font-weight-normal'>Vending UnitID : {token.unitId}</span>
                        </div>
                        <div className='card-text d-flex flex-row justify-content-between'>
                           <span className='font-weight-normal'></span>
                           <span className='font-italic font-weight-bold'>Token : {token.token}</span>
                        </div>
                     </div>
                  </div>
               </div>
            ) : (
               <div className='card card-custom mb-1'>
                  <div className='card-body'>
                     <h6 className='card-title text-muted'>No Token</h6>
                  </div>
               </div>
            )}
            {Object.keys(payment).length !== 0 ? (
               <div className='card card-custom mb-2'>
                  <div className='card-body'>
                     <h6 className='card-title text-muted'>
                        Payment <MdPayment />
                     </h6>
                     <hr />
                     <div className='card-text d-flex flex-row justify-content-between'>
                        <span className='font-weight-bold'>Transaction #: {payment.transactionId}</span>
                        <span className='font-italic font-weight-light text-muted'>{payment.paymentDateTime}</span>
                     </div>
                     <div className='card-text d-flex flex-column justify-content-between'>
                        <div>
                           <span className='font-weight-normal'>
                              External TransactionId:
                              {payment.externalTransactionId}
                           </span>
                        </div>
                        <div>
                           <span className='font-weight-normal'>Paid amount: {payment.paymentAmount} FRW</span>
                        </div>
                        <div className='card-text d-flex flex-row justify-content-between'>
                           <span className='font-weight-normal'></span>
                           <span className='font-italic font-weight-bold text-info'>{payment.paymentStatusId.paymentStatusName}</span>
                        </div>
                     </div>
                  </div>
               </div>
            ) : (
               <div className='card card-custom mb-1'>
                  <div className='card-body'>
                     <h6 className='card-title text-muted'>No Payment</h6>
                  </div>
               </div>
            )}
            {notifications.map((notification, index) => (
               <div key={index} className='card card-custom-bg card-custom mb-1'>
                  <div className='card-body'>
                     <h6 className='card-title text-muted'>
                        Notification <MdNotifications />
                     </h6>
                     <hr />
                     <div className='card-text d-flex flex-row justify-content-between'>
                        <span className='font-weight-bold'>Sender : {notification.sender}</span>
                        <span className='font-italic font-weight-light text-muted'>{notification.notificationDateTime}</span>
                     </div>
                     <div className='card-text d-flex flex-column justify-content-between'>
                        <div>
                           <span className='font-weight-normal'>Recipient: {notification.recipient}</span>
                        </div>
                        <div>
                           <span className='font-weight-normal'>Time: {notification.notificationDatetime}</span>
                        </div>
                        <div>
                           <span className='font-weight-bold' style={{ fontSize: 16 }}>
                              <FaSms />
                           </span>
                           <span className='font-weight-light'> {notification.notificationText}</span>
                        </div>
                        <div className='card-text d-flex flex-row justify-content-between'>
                           <span className='font-weight-normal'>Retrys {notification.deliveryRetryCount}</span>
                           <span className='font-italic font-weight-bold text-info'>{notification.notificationStatus.notificationStatusName}</span>
                        </div>
                        {deliveryStatus && (
                           <div className='card-text d-flex flex-row justify-content-between'>
                              <span className='font-weight-normal btn-link-custom'>{deliveryStatus}</span>
                           </div>
                        )}
                     </div>
                  </div>
               </div>
            ))}
            <Button type='submit' className='btn btn-sm btn-custom text-white mb-4' onClick={(evt) => resendSms(evt)}>
               Resend <MdTextsms />
            </Button>
         </div>
      </div>
   );
}
